import moment from "moment-timezone";

export const VALUE_MAPPERS = {
  arrayBooleanInt: (valueArray) => {
    const value = valueArray?.[0];
    return !!+value ? "Yes" : "No";
  },

  custom: (mapperFn) => mapperFn,

  accessControl: (_cellValue, rowData, storeUser) => {
    const isBookingControlled = rowData?.is_booking_controlled?.[0] === "true";
    const bookableForUsers = rowData?.bookable_for_users;
    const userInList = bookableForUsers?.some(
      user => user === storeUser?.id || user === storeUser?.user
    );
    const cidmGroupName = rowData?.cidm_group_name?.[0];

    if (isBookingControlled) {
      if (userInList) return "Allowed";
      if (cidmGroupName) return "Training Required";
      return "Restricted";
    }
    return "Allowed";
  },
  instrumentAvailability: (cellValue) => {
    const value = cellValue?.[0]?.toLowerCase() ?? "available";
    const description = value.split("_")[0];
    return description.charAt(0).toUpperCase() + description.slice(1);
  },
  equipment: (_cellValue, rowData) => {
    const { bookedEquipments } = rowData;
    return bookedEquipments?.toString();
  },
  dateFrom: (_cellValue, rowData, storeUser) => {
    const { dateFrom } = rowData;
    if (!dateFrom || !storeUser?.timezone) return dateFrom;
    return moment(dateFrom).tz(storeUser.timezone).format();
  },
  dateTo: (_cellValue, rowData, storeUser) => {
    const { dateTo } = rowData;
    if (!dateTo || !storeUser?.timezone) return dateTo;
    return moment(dateTo).tz(storeUser.timezone).format();
  },
  reservedForUsers: (_cellValue, rowData) => {
    const { bookedUsers } = rowData;
    if (!bookedUsers || !Array.isArray(bookedUsers)) return "";
    return bookedUsers.map(user => `${user.givenName} (${user.name})`).join(", ");
  },
  elnId: (cellValue) => {
    const { name } = cellValue;
    console.debug({ cellValue, name });
    if (!name) return "-";
    return name;
  },
};

export const EXPORT_COLUMN_CONFIG = {
  is_hazardous: { mapper: VALUE_MAPPERS.arrayBooleanInt },
  should_assisted: { mapper: VALUE_MAPPERS.arrayBooleanInt },

  isHazardous: { mapper: VALUE_MAPPERS.arrayBooleanInt },
  shouldAssisted: { mapper: VALUE_MAPPERS.arrayBooleanInt },

  bookingAccessControl: { mapper: VALUE_MAPPERS.accessControl },
  booking_access_control: { mapper: VALUE_MAPPERS.accessControl },

  instrumentAvailability: { mapper: VALUE_MAPPERS.instrumentAvailability },
  instrument_availability: { mapper: VALUE_MAPPERS.instrumentAvailability },

  equipment: { mapper: VALUE_MAPPERS.equipment },
  reservedForUsers: { mapper: VALUE_MAPPERS.reservedForUsers },

  dateFrom: { mapper: VALUE_MAPPERS.dateFrom },
  date_from: { mapper: VALUE_MAPPERS.dateFrom },

  dateTo: { mapper: VALUE_MAPPERS.dateTo },
  date_to: { mapper: VALUE_MAPPERS.dateTo },

  elnId: { mapper: VALUE_MAPPERS.elnId },
  eln_id: { mapper: VALUE_MAPPERS.elnId },
};

const EXCLUDED_COLUMNS = ['actions', 'detailExpander'];

export const getExportableColumnKeys = (columnDefs) => {
  if (!columnDefs || !Array.isArray(columnDefs)) return undefined;

  return columnDefs
    .filter(col => !EXCLUDED_COLUMNS.includes(col.field))
    .map(col => col.field)
    .filter(field => field !== undefined);
};

export const createExportCellProcessor = (customConfig = {}, storeUser = null) => {
  const config = { ...EXPORT_COLUMN_CONFIG, ...customConfig };

  return (params) => {
    console.debug("createExportCellProcessor", { customConfig, storeUser, params });
    const { column, node, value } = params;
    const colId = column.getColId();


    if (config[colId]) {
      const { mapper } = config[colId];
      const cellValue = node?.data?.[colId];

      return mapper(cellValue, node?.data, storeUser);
    }

    return value;
  };
};

export const createClipboardCellProcessor = (customConfig = {}, storeUser = null) => {
  const config = { ...EXPORT_COLUMN_CONFIG, ...customConfig };

  return (params) => {
    const { column, node, value } = params;
    const colId = column.colId;
    console.debug({ column, node, value });

    if (config[colId]) {
      const { mapper } = config[colId];
      const cellValue = node?.data?.[colId];
      return mapper(cellValue, node?.data, storeUser);
    }

    return value;
  };
};

export const createDefaultCsvExportParams = (customConfig = {}, additionalParams = {}, storeUser = null) => ({
  onlySelected: true,
  processCellCallback: createExportCellProcessor(customConfig, storeUser),
  ...additionalParams,
});

export const createDefaultExcelExportParams = (customConfig = {}, additionalParams = {}, storeUser = null) => ({
  onlySelected: true,
  processCellCallback: createExportCellProcessor(customConfig, storeUser),
  ...additionalParams,
});
